<template lang="pug">
.home.d-flex
  .sidebar.scrollable.py-3.pl-3.pr-2
    UserStatPanel(
      :user='user'
      :notificationCount='notificationCount'
      @reloadAfterError='loadCurrentUser()'
    )
    GenericCard.pt-3(size='33')
      MenuItem(title='ทำรายการขาย' @click="$router.push('/sales/new-order')")
      MenuItem(title='ดูประวัติการขาย' @click="$router.push('/sales/history')")
      MenuItem(title='เป้าและคอมมิชชั่น' @click="$router.push('/sales/profile-performance')")
      MenuItem(title='ตั้งค่าบัญชีส่วนตัว' @click="$router.push('/sales/settings')")
      MenuItem(title='ออกจากระบบ' @click="$store.dispatch('logout')")

  .content.scrollable
    .py-3.pr-2.pl-0(v-if='stat')
      //- outstanding, dueToday, backOrder, awaitShipment
      .d-flex.flex-wrap
        template(v-for='(title, key) in statFields')
          StatItem(
            :key='key'
            :title='title'
            :badgeNumber='stat[key] ? stat[key].count : `...`'
            :value='stat[key] ? stat[key].total : `...`'

            :highlighted='key === selectedStatItem'
            @click='onStatItemSelected(key)'
          )

      //- dueList
      .flex-fill.pt-2.pb-3
        div(v-show='selectedStatItem === `outstanding`')
          OutstandingList(
            @finishLoading='tableDataLoaded(`outstanding`, $event)'
          )
        div(v-show='selectedStatItem === `dueToday`')
          DueTodayList(
            @finishLoading='tableDataLoaded(`dueToday`, $event)'
          )
        div(v-show='selectedStatItem === `backOrder`')
          BackOrderList(
            @finishLoading='tableDataLoaded(`backOrder`, $event)'
          )
        div(v-show='selectedStatItem === `awaitShipment`')
          AwaitShipmentList(
            @finishLoading='tableDataLoaded(`awaitShipment`, $event)'
          )
        div(v-show='selectedStatItem === `allOrdersToday`')
          AllOrdersTodayList(
            @finishLoading='tableDataLoaded(`allOrdersToday`, $event)'
            @itemClicked="showOrderDetail($event.data.id)"
          )
        //- template(v-else)
        //-   GenericCard(size='auto')

  NotificationPanel(
    style='position: fixed; top: 0; width: 100%'
    @dataLoaded='notifications = $event'
    @itemClicked='showOrderDetail($event.order_id)'
  )

</template>

<script>
/* eslint-disable arrow-body-style */
import UserStatPanel from '@/components/dashboard/UserStatPanel.vue';
import NotificationPanel from '@/components/_dialogs/NotificationPanel.vue';

import OutstandingList from '@/components/dashboard/panels/OutstandingList.vue';
import DueTodayList from '@/components/dashboard/panels/DueTodayList.vue';
import BackOrderList from '@/components/dashboard/panels/BackOrderList.vue';
import AwaitShipmentList from '@/components/dashboard/panels/AwaitShipmentList.vue';
import AllOrdersTodayList from '@/components/dashboard/panels/AllOrdersTodayList.vue';

export default {
  data: () => ({
    user: {},
    statFields: {
      outstanding: 'รายการค้างชำระ',
      dueToday: 'รายการครบกำหนดชำระ',
      backOrder: 'รายการตกค้าง (backorder)',
      awaitShipment: 'รายการรอจัดส่ง',
      allOrdersToday: 'รายการขายวันนี้',
    },
    stat: {},
    selectedStatItem: 'allOrdersToday',

    notifications: null,
    notificationCount: null,
  }),
  mounted() {
    this.loadCurrentUser();
  },
  watch: {
    notifications: {
      deep: true,
      handler() {
        // recalculate notificationCount
        this.notificationCount = this.notifications.reduce((total, notif) => {
          if (notif.read === 0) return total + 1;
          return total;
        }, 0);
      },
    },
  },
  methods: {
    async loadCurrentUser() {
      this.isLoading = true;

      try {
        const res = await this.$api.user.current();
        if (res.status === 200) {
          this.user = res.data;
        }
      } catch (e) {
        console.log(e);
        this.user = null;
      }

      this.isLoading = false;
    },
    onStatItemSelected(statItemKey) {
      // alert(e);
      this.selectedStatItem = statItemKey;
    },

    async showOrderDetail(id) {
      try {
        const res = await this.$api.order.getWithId(id);
        this.$router.push({
          name: 'sales.history', // can't use path, cause it WON'T allow passing hidden params
          params: {
            sellRecord: res.data,
          },
        });
        console.log(res);
      } catch (e) {
        console.log(e);
      }
    },

    tableDataLoaded(key, elm) {
      console.log(elm);
      this.stat[key] = {
        count: elm.total,
        // total: (
        //   elm.reduce((total, order) => (total + Number(order.total)), 0)
        // ),
      };
    },
  },
  components: {
    UserStatPanel,
    NotificationPanel,

    OutstandingList,
    DueTodayList,
    BackOrderList,
    AwaitShipmentList,
    AllOrdersTodayList,
  },
};
</script>

<style lang="scss">
.home {
  max-width: 1200px;
  margin: 0 auto;

  .sidebar {
    // ...
  }
  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .generic-card {
    // padding-left: 0;
    // padding-bottom: 0;
    padding: 8px;
  }
}
</style>
